var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowlessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32271 0.441993C6.71501 0.0803483 7.32637 0.0898928 7.70711 0.470627L13.7071 6.47063C14.0976 6.86115 14.0976 7.49432 13.7071 7.88484C13.3166 8.27537 12.6834 8.27537 12.2929 7.88484L7 2.59195L1.70711 7.88484C1.31658 8.27536 0.683417 8.27536 0.292893 7.88484C-0.0976304 7.49432 -0.0976304 6.86115 0.292894 6.47063L6.29289 0.470627C6.30282 0.460706 6.31275 0.45115 6.32271 0.441993Z",
    fill: "#151515",
    className: "hc-icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowlessIcon);
export default __webpack_public_path__ + "static/media/showless-icon.748e94fb363937609f3e1edfa28ceb25.svg";
export { ForwardRef as ReactComponent };